export const BUILDWISE_MODULES = {
  HOME: 'Home',
  PROCEDURES: 'Procedures',
  PARTNERS: 'Partners',
  PROJECTS: 'Projects',
  INSIGHTS: 'Insights',
};
